import { render, staticRenderFns } from "./tabSelect.vue?vue&type=template&id=538defff"
import script from "./tabSelect.vue?vue&type=script&lang=js"
export * from "./tabSelect.vue?vue&type=script&lang=js"
import style0 from "./tabSelect.vue?vue&type=style&index=0&id=538defff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports